import './orderScreen.scss';
import React, { useEffect, useState } from 'react';
import { globalState } from '@/stores';
import { Button, message, Radio, RadioChangeEvent, Space, Spin } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { ApiQueryOrderBySeatConfig, ApiSaveOrderBySeatConfig } from '@/request/api';

enum OrderScreenStatus {
  ON = 1,
  OFF = 2,
}

export default function OrderScreen () {
  const { i18n } = globalState;
  const [loading, setLoading] = useState<boolean>(false);

  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [initData, setInitData] = useState<OrderScreenStatus>(OrderScreenStatus.OFF);
  const [orderBySeatValue, setOrderBySeatValue] = useState<OrderScreenStatus>(OrderScreenStatus.OFF);

  const onChange = (e: RadioChangeEvent) => {
    setOrderBySeatValue(e.target.value);
  };

  const cancelEdit = () => {
    setIsEdit(false);
    setInitData(initData)
  };

  const saveOrderScreenConfig = async () => {
    setLoading(true)

    const params = {
      ORDER_BY_SEAT_MODE: orderBySeatValue,
    }

    const { data } = await ApiSaveOrderBySeatConfig(params)

    if (data) {
      message.success('success', 2)
      setIsEdit(false)
    }

    setLoading(false)
  };

  const queryOrderBySeatConfig = async () => {
    setLoading(true)
    const { data } = await ApiQueryOrderBySeatConfig()

    if (data)  {
      setOrderBySeatValue(data?.ORDER_BY_SEAT_MODE || 2)
      setInitData(data?.ORDER_BY_SEAT_MODE || 2)
    }

    setLoading(false)
  }


  useEffect(() => {
    queryOrderBySeatConfig()
  }, [])

  return (
    <Spin spinning={loading}>
      <div className="orderScreen">
        <div className="top">
          <div className="btn-box" style={{ textAlign: 'right' }}>
            {isEdit ? (
              <>
                <Button
                  onClick={() => cancelEdit()}
                  style={{ marginRight: '16px' }}
                >
                  {i18n.t('cancel')}
                </Button>
                <Button onClick={() => saveOrderScreenConfig()} type="primary">
                  {i18n.t('save')}
                </Button>
              </>
            ) : (
              <Button
                onClick={() => setIsEdit(true)}
                type="primary"
                icon={<EditOutlined />}
              >
                {i18n.t('edit_1')}
              </Button>
            )}
          </div>
        </div>

        <div>
          <div>{i18n.t('dashboard_front_of_house_order_screen_order_by_seat')}</div>

          <div style={{ margin: '10px 0' }}>
            {i18n.t('dashboard_front_of_house_order_screen_order_by_seat_reminder')}
          </div>

          <Radio.Group onChange={onChange} value={orderBySeatValue} disabled={!isEdit}>
            <Space direction="vertical">
              <Radio value={1}>{i18n.t('pc_online_orders_on')}</Radio>
              <Radio value={2}>{i18n.t('pc_online_orders_off')}</Radio>
            </Space>
          </Radio.Group>
        </div>
      </div>

    </Spin>

  );
}
